import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import RaisedButton from 'material-ui/RaisedButton';
import {
  HeaderDiv,
  HeaderTitleDiv,
} from '../../pages';
import { WHITE } from '../../config/colors';

const SignInContainer = styled.div` 
    margin: 0 15px 0;
    text-align: center;
`;

const CheckoutGuest = (props) => {
  const getSecondaryColor = () => `#${props.secondaryColor}`;
  const {
    openLoginForm,
  } = props;

  return (
    <div className="treez-checkout">
      <HeaderDiv>
        <HeaderTitleDiv>CHECKOUT</HeaderTitleDiv>
      </HeaderDiv>
      <div className="treez-checkout-items-content">
        <div className="treez-checkout-items">
          <React.Fragment>
            <div className="no-items guest">No items in your cart yet.</div>
            <SignInContainer>
              <RaisedButton
                backgroundColor={getSecondaryColor()}
                labelColor={WHITE}
                label="Sign In"
                labelStyle={{ fontWeight: 700 }}
                onClick={openLoginForm}
              />
            </SignInContainer>
          </React.Fragment>
        </div>
      </div>
    </div>
  );
};

CheckoutGuest.propTypes = {
  secondaryColor: PropTypes.string.isRequired,
  openLoginForm: PropTypes.func.isRequired,
};

export default CheckoutGuest;



// WEBPACK FOOTER //
// ./src/components/Checkout/CheckoutGuest.jsx